export default "__VITE_ASSET__NBzTQbeP__"